
const TimerIcon = ({running}) => {
    return (
        <span className="material-icons-outlined timer-icon">{running ? "timer" : "timer_off"}</span>
    )
}

export default TimerIcon